import { createSlice } from "@reduxjs/toolkit";

const proposalSlice = createSlice({
  name: "proposal",
  initialState: {
    proposalData: {},
    active: 0,
    proposerPrimaryId: "",
    members: [],
    tAndCAgree: "N",
    cKycStatus: false,
    cKycUploadStatus: {
      identity_proof: false,
      address_proof: false,
    },
    cKycUploadLoader: {
      identity_proof: false,
      address_proof: false,
      pan_card: false,
    },
    cKycFailCount: 0,
    cKycResponse: {},
    metaData: {},
  },
  reducers: {
    setProposalData: (state, action) => {
      state.proposalData = { ...state.proposalData, ...action.payload };
    },
    setActive: (state, action) => {
      state.active = action.payload;
    },
    setPrimaryProposerId: (state, action) => {
      state.proposerPrimaryId = action.payload;
    },
    setProposalMembers: (state, action) => {
      state.members = action.payload;
    },
    setTAndCAgree: (state, action) => {
      state.tAndCAgree = action.payload;
    },
    setCKycStatus: (state, action) => {
      state.cKycStatus = action.payload;
    },
    setCKycUploadStatus: (state, action) => {
      state.cKycUploadStatus = {
        ...(state.cKycUploadStatus ?? {}),
        ...action.payload,
      };
    },
    resetCkycUploadStatus: (state) => {
      state.cKycUploadStatus = {
        identity_proof: false,
        address_proof: false,
      };
    },
    setCKycUploadLoader: (state, action) => {
      state.cKycUploadLoader = {
        ...(state.cKycUploadLoader ?? {}),
        ...action.payload,
      };
    },
    setCKycFailCount: (state, action) => {
      state.cKycFailCount = action?.payload ?? 0;
    },
    setCKycResponse: (state, { payload }) => {
      state.cKycResponse = payload;
    },
    setMetaData: (state, { payload }) => {
      state.metaData = payload;
    },
  },
});

export const {
  setProposalData,
  setActive,
  setPrimaryProposerId,
  setProposalMembers,
  setTAndCAgree,
  setCKycStatus,
  setCKycUploadStatus,
  setCKycUploadLoader,
  setCKycFailCount,
  setMetaData,
  setCKycResponse,
  resetCkycUploadStatus,
} = proposalSlice.actions;

export default proposalSlice.reducer;
